import { render } from "./BaseCustomPermissions.vue?vue&type=template&id=33941236"
import script from "./BaseCustomPermissions.vue?vue&type=script&lang=js"
export * from "./BaseCustomPermissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__